import { motion } from "framer-motion";

const InstallAddonCta = ({ view = 'horizontal' }) => {
  return (
    <div className={`install-addon-block-wrapper ${view === 'vertical' ? 'vertical' : ''}`}>
      <div className="addon-block-element">
        <img style={{ marginLeft: '-12px' }} className="addon-block-image" src={'excel-logo.svg'} alt="" />
        <h5 className="addon-block-title">Ask AI Without Leaving Microsoft Excel</h5>
        <span className="addon-block-description">Download our Excel Add-in.</span>
        <a
          href="https://pages.store.office.com/addinsinstallpage.aspx?assetid=WA200006180&rs=en-US&correlationId=5eea722e-b620-fe83-c791-460662cb32d5"
          target={"_blank"}
          rel="noreferrer"
        >
          <button className={`addon-block-button`}>
            Download
          </button>
        </a>
      </div>
      <div className="addon-block-element">
        <img style={{ marginLeft: '-5px' }} className="addon-block-image" src={'sheets-logo.svg'} alt="" />
        <h5 className="addon-block-title">Ask AI Without Leaving Google Sheets</h5>
        <span className="addon-block-description">Download our Chrome Extension.</span>
        <a
          href="https://chrome.google.com/webstore/detail/ai-excel-bot-extension/ehpdalbmeiockgpaikchiciodighaedg"
          target={"_blank"}
          rel="noreferrer"
        >
          <button className={`addon-block-button`}>
            Download
          </button>
        </a>
      </div>
    </div>
  );
};

export default InstallAddonCta;
